/**
 * SectionBadge Component
 *
 * Renders a reusable badge for section headers.
 * Features:
 * - Displays a gradient text badge with dashed border and pulse animation
 * - Accepts a text prop to customize the badge label
 *
 * @param {SectionBadgeProps} props - Props for the SectionBadge component
 * @param {string} props.text - The text to display inside the badge
 *
 * @returns {JSX.Element} The rendered section badge
 */
'use client';

import React from 'react';

interface SectionBadgeProps {
  text: string;
}

/**
 * Renders a styled badge for section headers.
 */
export default function SectionBadge({ text }: SectionBadgeProps) {
  return (
    <div className="inline-flex items-center justify-center gap-2.5 px-4 py-2 rounded-2xl border-[1.5px] border-dashed border-androia-border bg-transparent badge-pulse">
      <span className="gradient-text font-manrope font-semibold text-base leading-8">{text}</span>
    </div>
  );
}
